import { FC } from 'react';
import { FFHeading, HeadingSizeProp } from 'src/atoms/ff-heading';
import { FFImage, FFImageProps } from 'src/atoms/ff/ff-image';
import { FMHLink } from 'src/atoms/fmh-link';
import { PartnerTier, FMHLogo } from './dto';
import styles from './fmh-logo-strip.module.scss';
import { FMHLogoStripProps } from '.';

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'logo-strip': any;
        }
    }
}

const FMHLogoStrip: FC<FMHLogoStripProps> = (props: FMHLogoStripProps): JSX.Element => {
    const getPartnerTierClass = (tier: PartnerTier): string | undefined => {
        switch (tier) {
            case PartnerTier.FifaPartner:
                return styles['FIFA_Partners'];
            case PartnerTier.TournamentSponsor:
                return styles['FIFA_Tournament_Partner'];
            case PartnerTier.RegionalSupporter:
                return styles['FIFA_National_supporters'];
        }
    };

    const getSponsorIcon = (image: FFImageProps, link: string, tier: PartnerTier): JSX.Element | null => {
        image.imageClassName = `${styles.sponsorImage} ${getPartnerTierClass(tier)}`;
        return (
            <FMHLink href={link}>
                <FFImage {...image} />
            </FMHLink>
        );
    };

    function canAutomaticLogoStripComponentBeUsed(): boolean {
        return customElements.get('logo-strip') !== undefined && props.isAutomaticComponentUsed === true;
    }

    if (canAutomaticLogoStripComponentBeUsed()) {
        const path = window.location.pathname.split('/');
        const tiers = JSON.stringify(props.tiers ?? []);
        const locale = path[1];
        return (
            <logo-strip
                data-disable-geolocation={props.isGeolocationEnabled}
                data-competition={props.competition}
                data-event-name={props.eventId}
                data-tiers={tiers}
                data-language={locale}
            ></logo-strip>
        );
    } else {
        return (
            <div className={styles.sponsorsWrapper}>
                <FFHeading text={props.label} className={styles.title} size={HeadingSizeProp.H3} />

                <div className={styles.imagesWrapper}>
                    {props.images.map((logo: FMHLogo, index: number) => (
                        <div className={`${styles.sponsorImageWrapper} ${getPartnerTierClass(props.tier)}`} key={index}>
                            {getSponsorIcon(logo.image, logo.link, props.tier)}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
};

export default FMHLogoStrip;
